import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { ListItem as ListItemUI } from '../../../primitives/List/index.js';
export const ListItem = /*#__PURE__*/_styled(ListItemUI, process.env.NODE_ENV === "production" ? {
  target: "e1es0p2h0"
} : {
  target: "e1es0p2h0",
  label: "ListItem"
})(process.env.NODE_ENV === "production" ? {
  name: "18zed2t",
  styles: "font-weight:inherit"
} : {
  name: "18zed2t",
  styles: "font-weight:inherit/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxpc3RJdGVtLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUUyQyIsImZpbGUiOiJMaXN0SXRlbS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IExpc3RJdGVtIGFzIExpc3RJdGVtVUkgfSBmcm9tICcuLi8uLi8uLi9wcmltaXRpdmVzL0xpc3QvaW5kZXguanMnO1xuZXhwb3J0IGNvbnN0IExpc3RJdGVtID0gc3R5bGVkKExpc3RJdGVtVUkpIGBcbiAgZm9udC13ZWlnaHQ6IGluaGVyaXQ7XG5gO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9TGlzdEl0ZW0uanMubWFwIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});